import styled from 'styled-components';

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;

  margin: 0;
  padding: 0;

  width: 100%;

  list-style: none;
`;

export const ListItem = styled.li``;
